const doc = [({"en":({"js":({"components":({"plans":({"sign_up_modal":({"period_option":({"x_months_for_price":"%{months} months for %{price}"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;